import React from "react";
import {
  Box,
  Typography,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

import Setting from "../../../assets/Setting.png";
// import { inputStyles } from '../../../Config/Style';
import CustomSelect from "../../CustomSelect";

const AdditionalCost = ({
  items,
  products,
  addItem,
  removeItem,
  handleProductChange,
  handleQuantityChange,
  handleTaxChange,
  productOptions,
  handleAddClick,
  selectedSupplierId,
  isSupplierSelected,
  mode,
  handleAdditionalCostChange,
  entities,
  handleOtherCostChange
}) => {
  const formatValue = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return value;
    // Check if it's a whole number and return as is, otherwise format to 2 decimal places.
    // This handles integers and floats correctly.
    return String(value);
  };

  const otherCostOptions = Object.values(entities?.other_costs?.values || {});

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        ADDITIONAL COSTS
      </Typography>

      {/* <IconButton onClick={addItem} disabled={!isSupplierSelected}>
        <Box sx={{
          border: "1px solid #95ABEB",
          width: "20px",
          display: 'flex',
          justifyContent: "center",
          p: 1
        }}
        disabled={!isSupplierSelected}
        >
          <img src={AddImage} alt='Add' />
        </Box>
      </IconButton> */}
      <IconButton
        onClick={addItem}
        disabled={mode === "VIEW" || !isSupplierSelected}
        sx={(theme) => ({
          p: 0,
          border: `1px solid ${!isSupplierSelected ? "grey" : "#95ABEB"}`,
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "8px",
        })}
      >
        <AddIcon sx={{ color: !isSupplierSelected ? "grey" : "#95ABEB" }} />
      </IconButton>

      <TableContainer
        sx={{
          borderRadius: 2,
          border: "1px solid",
          mt: 2,
          width: "100%",
          overflow: "scroll",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell>
                <img
                  src={Setting}
                  style={{ filter: "invert()", width: "30px" }}
                  alt="setting"
                />
              </TableCell> */}
              <TableCell>Description</TableCell>
              {/* <TableCell>Comment</TableCell>
              <TableCell>Supplier SKU</TableCell> */}
              {/* <TableCell>Unit</TableCell> */}
              <TableCell>Quantity</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Tax Rule</TableCell>
              <TableCell>Total</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={item.id || item.href || index}>
                {/* <TableCell>
                  <IconButton
                    // onClick={() => removeItem(item.id)}
                    disabled={mode === "VIEW" ? true : false}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell> */}
                <TableCell style={{ width: "17%" }}>
                  {item.isNew && mode !== "VIEW" ? (
                    <CustomSelect
                      name="description"
                      value={item.description || ""}
                      data={otherCostOptions.map((c) => c.description)}
                      handleChange={(e) =>
                        handleOtherCostChange(item.id, e.target.value)
                      }
                      searchable
                      placeholder="Type to search..."
                    />
                  ) : (
                    <TextField
                      value={item.description || ""}
                      variant="standard"
                    disabled={mode === "VIEW"}
                      onChange={(e) =>
                        handleAdditionalCostChange(item.id, "description", e.target.value)
                      }
                    />
                  )}
                </TableCell>

                <TableCell>
                  <TextField
                    type="number"
                    value={formatValue(item.quantity)}
                    variant="standard"
                    disabled={mode === "VIEW"}
                    onChange={(e) =>
                      handleAdditionalCostChange(
                        item.id,
                        "quantity",
                        e.target.value
                      )
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    value={formatValue(item.price)}
                    variant="standard"
                    disabled={mode === "VIEW"}
                    onChange={(e) =>
                      handleAdditionalCostChange(item.id, "price", e.target.value)
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    value={formatValue(item.discount)}
                    variant="standard"
                    disabled={mode === "VIEW"}
                    onChange={(e) =>
                      handleAdditionalCostChange(
                        item.id,
                        "discount",
                        e.target.value
                      )
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    value={formatValue(item.tax_rule)}
                    variant="standard"
                    disabled={mode === "VIEW"}
                    onChange={(e) =>
                      handleAdditionalCostChange(
                        item.id,
                        "tax_rule",
                        e.target.value
                      )
                    }
                  />
                </TableCell>

                <TableCell>
                  <TextField
                    value={formatValue(item.total)}
                    variant="standard"
                    disabled={true}
                  />
                </TableCell>

                <TableCell>
                  <IconButton
                    onClick={() => removeItem(item.id || item.href)}
                    sx={{ display: `${mode === "VIEW" && "none"}` }}
                    disabled={mode === "VIEW"}
                  >
                    <CloseOutlined />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Button
          sx={{ fontSize: "12px", m: 2 }}
          onClick={addItem}
          disabled={mode === "VIEW" || !isSupplierSelected}
          startIcon={<AddIcon />}
        >
          Add More Items
        </Button>
      </TableContainer>
    </Box>
  );
};

export default AdditionalCost;
